import { useEffect, useState } from "react";
import { GetServerEmailError } from "../../../app/validation";
import { useEmailErrorMessage } from "../../../UIComponents/Form/EmailField";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../app/store";
import { postInitActivateAccount } from "../authentificationSlice";
import ResendActivationCard from "./resendActivationCard";
import { Dialog } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { LoadingPage } from "../../CommonPages/loadingPage";
import SuccessCard from "../../CommonPages/successCard";

export function InitActivateAccount() {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState<string | undefined>();
    const dispatch = useDispatch<AppDispatch>();
    const authData = useSelector((state: RootState) => state.AuthentificationSlice);
    const { t } = useTranslation();
    const getEmailError = useEmailErrorMessage();
    const [openDialog, setOpenDialog] = useState(false);
    const [success, setSuccess] = useState(false);
    const [messsage, setMesssage] = useState('');

    const handleOpenDialog = () => setOpenDialog(!openDialog);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        submitFunction(email);
    };

    const submitFunction = (email: string) => {
        const emailProblem = getEmailError(email);
        if (emailProblem) {
            setEmailError(emailProblem);
            return;
        }
        dispatch(postInitActivateAccount(email));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (authData.statusCode === '200' || authData.statusCode === 'OK') {
            setSuccess(true);
            setMesssage(t("RequestForAccountCreationWasResentCheckYourEmail"));
            handleOpenDialog();
        }
        else if (authData.statusCode !== '') {
            // A 400 on the email is a fixable typo, so it goes on the field.
            const serverEmailError = GetServerEmailError(authData.statusCode, authData.error);
            if (serverEmailError) {
                setEmailError(serverEmailError);
                return;
            }
            setSuccess(false);
            setMesssage(authData.error ?? t("AnErrorOccurred"));
            handleOpenDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authData.statusCode])

    if (authData.isLoading) {
        return (LoadingPage(authData.isLoading))
    }

    return (
        <div className="flex justify-center m-[5%]">
            <form className="space-y-5" onSubmit={handleSubmit}>
                <ResendActivationCard onClickFunction={submitFunction} setEmailForm={setEmail} emailError={emailError} onEmailErrorClear={() => setEmailError(undefined)} />
                <input type="submit" style={{ display: "none" }} />
            </form>
            <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
                <SuccessCard onClickFunction={handleOpenDialog} text={messsage} success={success} />
            </Dialog>
        </div>
    )
}